import { call, select, put } from 'redux-saga/effects';
import getGaCookie from '@gcloud-npm/utils.common.get-ga-cookie';
import { normalizeRedirectError } from '@bitComponents/utils/adaByron';
import { megaMinderStatus } from '../minder/MegaMinder/megaMinderStatus';
import { sendRetargeting as sendRetargetingBit } from '../bitSagas/sendRetargeting';
import { actions as loaderControlActions } from '../reducers/loaderControl';
import { CHARACTERISTICS } from '../catalogConstants';
import { STRING_KEYS } from '../localizedStrings';
import { FLOW_TYPES } from '../flowDefinition/flowTypes';


const apisNeedsStore = state => state.apiNeeds;
const offerStore = state => state.offer;
const localizedStringsStore = state => state.localizedStrings;
const flowStore = state => state.flow;

export function* sendRetargetingAction(params) {
  const { normalizeHttpErrors, reduxUpdate } = params;
  const { clientInfo, productOfferingName, myProductsInfo } = yield select(apisNeedsStore);
  const { productOffering, colorId, storageId } = yield select(offerStore);
  const { localizedStrings } = yield select(localizedStringsStore);
  const flowInfo = yield select(flowStore);

  if (clientInfo && clientInfo.userIdPartyHash) {
    const token = yield call(grecaptcha.enterprise.execute, RECAPTCHA_SITE_KEY, {
      action: 'retargeting_collect',
    });

    const ga = getGaCookie();
    let sessionId = '';
    try {
      const sessionIdPromise = new Promise((resolve) => {
        gtag('get', 'G-J1GJWFY08P', 'session_id', resolve);
      });
      const response = yield sessionIdPromise;
      sessionId = response;
    } catch (error) {
      console.log(error);
    }

    const loginUrlComposed = normalizeRedirectError();

    const sendRetargetingInfoParams = {
      normalizeHttpErrors,
      reduxUpdate,
      data: {
        recaptchaToken: token,
        contactInfo: { encryptedPartyId: clientInfo.userIdPartyHash },
        campaign: {
          id: localizedStrings[STRING_KEYS.retargeting.id],
        },
        products: [
          {
            productOfferingId: productOffering,
            productName: productOfferingName,
            // promotion: { // TODO ESTUDIAR SI SACAR PROMO APLICADA EN INIT_CQ Y METERLA
            //   promotionId: 'idPromocion',
            //   promotionText: 'textoPromocion',
            // },
          },
        ],
        context: {
          url: btoa(loginUrlComposed),
        },
      },
    };
    if (ga) {
      const gaInfo = {
        client_id: ga,
      };
      if (sessionId) {
        gaInfo.session_id = sessionId;
      }
      sendRetargetingInfoParams.data.context.ga = JSON.stringify(gaInfo);
    }
    const characteristics = [];
    if (colorId) {
      characteristics.push({
        id: CHARACTERISTICS.COLOR,
        value: colorId,
      });
    }
    if (storageId) {
      characteristics.push({
        id: CHARACTERISTICS.STORAGE,
        value: storageId,
      });
    }
    if (characteristics.length > 0) {
      sendRetargetingInfoParams.data.products[0].characteristics = characteristics;
    }

    const { flowJson } = flowInfo;
    const { flowName } = flowJson;
    
    if(flowName === FLOW_TYPES.PACK){

      let additionalInfoObj = {
        "destinationProductOfferingId" : productOffering,
        "originProductOfferingId": myProductsInfo.convergentMainPoId,
      };

      sendRetargetingInfoParams.data.additionalInfo = JSON.stringify(additionalInfoObj);
    }

    try {
      const response = yield call(sendRetargetingBit, sendRetargetingInfoParams);
      return response;
    } catch (error) {
      const errorResponse = megaMinderStatus.OK;
      errorResponse.errorInfo = error;

      return errorResponse;
    }
  }
  return null;
}

const validateCaptcha = () => {
  return new Promise((res) => {
    grecaptcha.enterprise.ready(() => {
      return res();
    });
  });
};

export function* sendRetargeting(params) {
  yield put(loaderControlActions.setLoaderState({ loading: true }));

  const { showError, normalizeHttpErrors } = params;
  const reduxUpdate = { errorUpdate: showError };
  if (grecaptcha && grecaptcha.enterprise) {
    try {
      yield validateCaptcha();
      yield call(sendRetargetingAction, {
        normalizeHttpErrors,
        reduxUpdate,
      });
    } catch (error) {
      console.log(`Error sending retargeting action: ${error}`);
    }
  }
}
